import script from "./BoxCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoxCard.vue?vue&type=script&setup=true&lang=ts"

export default script